import React from "react"
import { has } from "lodash"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faThumbsUp } from "@fortawesome/free-solid-svg-icons"

class ReviewForm extends React.Component{
    constructor(){
        super()
        this.state = {
            originalComment: "",
            comment: "",
            prompt: "",
            error: "",
            cancelHidden: true,
            upvote: null
        }
        this.whiteSpaceTest = /^\s+$/
        this.textArea = React.createRef()
        this.upvoteBtn = React.createRef()
        this.downvoteBtn = React.createRef()
    }
    reviewEmpty = () => {
        return this.state.comment === "" || this.whiteSpaceTest.test(this.state.comment)
    }
    toggleUpvote = (e) =>{
        if (this.upvoteBtn.current.contains(e.target)){
            if (!this.reviewEmpty() && this.state.upvote === true){
                return
            }
            else if (this.reviewEmpty() && this.state.upvote === true){
                this.setState({ upvote: null }, () => this.submitUpvote());
            }
            else{
                this.setState({ upvote: true }, () => this.submitUpvote())
            }
        }
        else if (this.downvoteBtn.current.contains(e.target)){
            if (!this.reviewEmpty() && this.state.upvote === false){
                return
            }
            else if (this.reviewEmpty() && this.state.upvote === false){
                this.setState({ upvote: null }, () => this.submitUpvote());
            }
            else{
                this.setState({ upvote: false }, () => this.submitUpvote())
            }
        }
    }
    submitUpvote = () =>{
        fetch(`/api/store/project/${this.props.data.id}/review/add`,{
            method: "post",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                upvote: this.state.upvote,
                id: this.props.data.id,
            })
        })
        .then(res => res.json())
        .then(data =>{
            if (has(data, "error")){ throw data }
            if (this.reviewEmpty()){
                this.setState({
                    prompt: "Upvote posted! Consider writing something for the review as well!" 
                })
            }
            else{
                this.setState({
                    prompt: "Upvote changed! Feel free to edit your review as well!" 
                })
            }
        })
        .catch(data => this.setState({error: `Server: ${data.error}`}))
    }
    handleSubmit = (e) =>{
        e.preventDefault();
        if (this.validate() === true){
            fetch(`/api/store/project/${this.props.data.id}/review/add`,{
                method: "post",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    content: this.state.comment,
                    id: this.props.data.id,
                })
            })
            .then(res => res.json())
            .then(data => {
                if (has(data.error)){ throw data }
                this.setState({comment: data.result.content}, ()=>this.props.cancelEdit(data.result))
            })
            .catch(data => this.setState({error: `Server: ${data.error}`}))
        }
    }
    validate = () =>{
        //accept empty string but only submit the upvote don't post review
        if (this.reviewEmpty()
        //however, if the user want to empty the review, let them do it. 
        //so if the original comment isn't empty (user changed it to empty), post the new review.
        && this.state.originalComment === ""){
            if (this.state.prompt === ""){
                this.submitUpvote()
                this.setState({ 
                    comment: "",
                    prompt: "Upvote posted! Consider writing something for the review as well!" 
                })
                return false
            }
            //if the user clicks again without typing reviews, just refresh the page
            else{
                window.location.href = window.location.href + ""
                return false
            }
        }
        else{
            this.setState({ prompt: "" })
        }
        return true
    }
    handleChange = (e) =>{
        const {name, value} = e.target
        this.setState({[name]: value}, () =>{
            if (this.state.comment === "") this.setState({cancelHidden: true})
            if (this.state.comment !== "") this.setState({prompt: "", cancelHidden: false})
            this.changeTextAreaHeight()
        })
    }
    changeTextAreaHeight = () =>{
        this.textArea.current.style.height = (this.textArea.current.scrollHeight + 2) + "px"
    }
    componentDidMount(){
        this.setState({upvote: this.props.upvote})
        if (this.props.editReview === true) this.setState({comment: this.props.comment})
        this.setState({cancelHidden: this.state.comment === ""})
        this.setState({originalComment: this.props.comment})
        setTimeout(()=>this.changeTextAreaHeight(), 1)
    }
    render(){
        const { editReview, cancelEdit } = this.props
        const { upvote, prompt, error, cancelHidden, comment } = this.state
        return(    
            <div className="description">
            <button id="upvote" ref={this.upvoteBtn} className={`upvote ${upvote===true ? "active": "inactive"}`} onClick={this.toggleUpvote}>
                <FontAwesomeIcon icon={faThumbsUp}/>  
                Recommend
            </button>
            <button id="downvote" ref={this.downvoteBtn} className={`downvote ${upvote===false ? "active": "inactive"}`} onClick={this.toggleUpvote}>
                Don't Recommend
            </button>
            <form onSubmit={this.handleSubmit}>
                <div className={`reviewForm ${ (upvote !== null)? "display" : "hidden" }`}>
                    <div className="label">
                        Comment:
                    </div>
                    <textarea ref={this.textArea} id="textArea" onChange={this.handleChange} value={comment}
                        name="comment" placeholder="Voice your opinion and help the author improve!" style={{height: "70px"}}/>
                    {prompt !== "" && <p className="prompt">{prompt}</p>}
                    {error !== "" && <p className="error">{error}</p>}
                    <div className="reviewBtnGroup">
                        <button className={`reviewBtn ${(!editReview && cancelHidden) ? " hidden" : ""}`} onClick={(e) => cancelEdit(e)}>
                            Cancel
                        </button>
                        <button className="reviewBtn submit" onClick={(e) => this.handleSubmit(e)}>
                            Submit Feedback
                        </button>
                    </div>
                </div>
            </form>
            </div>
        )
    }
}

export default ReviewForm